import type { StateCreator } from 'zustand'
import resetter from '../resetter'
import type { Store } from '../useMainStore'

export type InterviewInviteState = {
  inviteInterviewId: string | null
  inviteDeadlineISO: string | null
  inviteReadTime: number | null
  inviteAnswerTime: number | null
  inviteEmails: string[]
  inviteEmailGraded: string
  inviteEmailPassed: string
  inviteEmailFailed: string
}

export type InterviewInviteActions = {
  setInviteInterviewId: (id: string | null) => void
  setInviteDeadlineISO: (iso: string | null) => void
  setInviteReadTime: (value: number | null) => void
  setInviteAnswerTime: (value: number | null) => void
  addInviteEmail: (email: string) => void
  removeInviteEmail: (email: string) => void
  setInviteEmails: (emails: string[]) => void
  setInviteEmailGraded: (text: string) => void
  setInviteEmailPassed: (text: string) => void
  setInviteEmailFailed: (text: string) => void
  resetInviteWorkflow: () => void
}

export type InterviewInviteSlice = InterviewInviteState & InterviewInviteActions

const initialInviteState: InterviewInviteState = {
  inviteInterviewId: null,
  inviteDeadlineISO: null,
  inviteReadTime: null,
  inviteAnswerTime: null,
  inviteEmails: [],
  inviteEmailGraded: '',
  inviteEmailPassed: '',
  inviteEmailFailed: '',
}

export type CreateInterviewInviteSlice = StateCreator<Store, [], [], InterviewInviteSlice>

export const createInterviewInviteSlice: CreateInterviewInviteSlice = (set, get) => {
  resetter.addResetter(() => set(initialInviteState))

  return {
    ...initialInviteState,

    setInviteInterviewId: (id) => set({ inviteInterviewId: id }),
    setInviteDeadlineISO: (iso) => set({ inviteDeadlineISO: iso }),
    setInviteReadTime: (value) => set({ inviteReadTime: value }),
    setInviteAnswerTime: (value) => set({ inviteAnswerTime: value }),
    addInviteEmail: (email) => set((state) => ({ inviteEmails: Array.from(new Set([...(state.inviteEmails || []), email.trim()])).filter(Boolean) })),
    removeInviteEmail: (email) => set((state) => ({ inviteEmails: (state.inviteEmails || []).filter((e) => e !== email) })),
    setInviteEmails: (emails) => set({ inviteEmails: emails }),
    setInviteEmailGraded: (text) => set({ inviteEmailGraded: text }),
    setInviteEmailPassed: (text) => set({ inviteEmailPassed: text }),
    setInviteEmailFailed: (text) => set({ inviteEmailFailed: text }),
    resetInviteWorkflow: () => set(initialInviteState),
  }
} 